import styles from './search.module.scss';
import {
  CommunitiesAutocomplete,
  CommunityAutocomplete,
  MemberAutocomplete,
  SitesAutocomplete,
  AdminUsersAutocomplete,
} from './search.utils';
import { useLocation } from 'react-router-dom';


const ENV = (import.meta as any).env;

/* eslint-disable-next-line */
function getSearchComponent(props: any) {
  switch (props?.context) {
    case 'admin-management':
      return <AdminUsersAutocomplete />;
    break;  
    case 'communities':
      return <CommunitiesAutocomplete />;
      break;
    case 'community':
    case 'community-energy':
    case 'community-economics':
      return <CommunityAutocomplete context={ props?.context || 'community'} />;
      break;
    case 'site-energy':
    case 'site-economics':
    case 'site':
      return <MemberAutocomplete />;
      break;
    case 'member':
    case 'member-energy':
    case 'member-economics':
      return <MemberAutocomplete />;
      break;
    case 'household':
    case '':

      if (props?.context === '' && ENV?.VITE_APP_IS_WEB !== 'true') {
        return <SitesAutocomplete />;
      } else if (props?.context === 'household') {
        return <SitesAutocomplete />;
      }
      return <></>;
      
    default:
      return <></>;
      break;
  }
}

export function Search() {
  const location = useLocation();
  const pathSegment = location.pathname.split('/')[1]; 

  return (
    <div className={styles.SearchWrapper}>
      <div className={styles.Search}>
        {getSearchComponent({
          context: pathSegment,
        })}
      </div>
    </div>
  );
}

export default Search;
